import { Map, fromJS } from 'immutable';

export function request(state, { marketId, dividendType, data }) {
    return state.set(
        'add-dividend',
        (state.get('add-dividend') || Map())
            .set(marketId, Map({
                type: dividendType,
                dividend: fromJS(data),
                state: 'IN_PROGRESS'
            }))
    );
}

export function error(state, { marketId, errors }) {
    return state.set(
        'add-dividend',
        (state.get('add-dividend') || Map())
            .set(marketId, Map({
                dividend: state.getIn([ 'add-dividend', marketId, 'dividend' ]),
                state: 'ERROR',
                errors: fromJS(errors)
            }))
    );
}

export function finish(state, { marketId, market }) {
    return state
        .set(
            'add-dividend',
            (state.get('add-dividend') || Map())
                .set(marketId, Map({
                    dividend: state.getIn([ 'add-dividend', marketId, 'dividend' ]),
                    state: 'FINISHED'
                }))
        )
        .setIn([ 'items', market.id ], fromJS(market));
}
